import {
    StrollerAllReviewsGalleryState,
    initialStrollerAllReviewsGalleryState,
    initialStrollersAllReviewsGalleriesState,
} from "@/mk2/apps/strollers/containers/StrollerAllReviewsGallery/StrollerAllReviewsGallery.reducers";
import { AppState } from "@/mk2/reducers";

export const getStrollerAllReviewsGalleryPageState = (
    state: AppState,
    strollerSlug: string,
): StrollerAllReviewsGalleryState =>
    (
        state.containers.strollers.strollersAllReviewsGalleries ||
        initialStrollersAllReviewsGalleriesState
    ).pages[strollerSlug] || initialStrollerAllReviewsGalleryState;
